<template>
  <div class="micro-list">
    <div
      v-for="d in rows"
      :key="d.label"
      class="row"
      :class="d.type"
    >
      <div class="label">{{ d.label }}</div>
      <div class="value">{{ d.percent.toFixed(1) }}%</div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['data'],

  computed:{
    rows(){
      let total = this.data.count
      let percs = this.data.values ? this.data.values.map((d)=>{
        return {
          ...d,
          percent: (100*d.count/total)
        }
      }) : []
      let first = percs.slice(0,2)
      let others = {label: `${this.$t('others')} (${this.data.unique-2})`, type:'others',  percent: first.reduce((sum,d)=>{
        return sum-d.percent
      },100)}
      return first.concat([others])
    }
  }
}
</script>

<style lang="stylus" scoped>
.micro-list
  display flex
  flex-direction column
  font-weight normal
  overflow hidden
  justify-content: flex-end;
  height: 100%;
  .row
    display flex
    border-bottom solid 1px #f0f0f0
    margin-bottom vw(5px)
    .label
      flex 1 1 auto
      font-weight bold
      white-space: nowrap;
      // max-width: vw(90px)
      overflow: hidden;
      text-overflow: ellipsis;
    &.others
      opacity 0.9
      .label
        font-weight normal
        color $grey
      .value
        color $grey
  .micro-stats &
    .row
      margin-bottom vw(10px) 
</style>
